var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEhIconMedicationsGray = function SvgEhIconMedicationsGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#767679",
    d: "M4.688 7.875h3.718c.292 0 .531.239.531.531a.533.533 0 0 1-.53.531h-3.72v2.126h3.72c.291 0 .53.239.53.53a.533.533 0 0 1-.53.532h-3.72v2.125h3.72c.291 0 .53.239.53.531a.533.533 0 0 1-.53.531h-3.72v1.063c0 1.169.957 2.125 2.125 2.125h6.376a2.13 2.13 0 0 0 2.124-2.125V5.75H4.688zM15.578 1.5H4.422a.797.797 0 0 0-.797.797V3.89c0 .44.357.797.797.797h11.156c.44 0 .797-.357.797-.797V2.297a.797.797 0 0 0-.797-.797",
    opacity: 0.7
  })));
};
export default SvgEhIconMedicationsGray;